import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpMethods } from '@cbre/http';
import { PrivacyMember } from '@shared/dialogs/private-asset-settings-dialog/privacy.model';

@Injectable()
export class TeamContactCardService extends HttpMethods {
  constructor(http: HttpClient) {
    super(http);
  }

  public getTeamMembers(teamId: number): Observable<PrivacyMember[]> {
    const uri = `/privacy/teams/${teamId}`;
    return this.httpGet(uri) as Observable<PrivacyMember[]>;
  }
}
